export default __webpack_public_path__ + "static/media/undraw_astronaut.4d9598e3.svg";